import { action, makeObservable } from 'mobx'

import MobileEventStore from '~/client/src/mobile/stores/EventStore/MobileEvents.store'
import MobileInitialState from '~/client/src/mobile/stores/MobileInitialState'
import MobileCommonStore from '~/client/src/mobile/stores/ui/MobileCommon.store'
import { IAppConfig } from '~/client/src/shared/Config'
import { clearProjectNotifications } from '~/client/src/shared/lists/notifications/clearProjectNotifications'
import { resetMapSelectionInputs } from '~/client/src/shared/stores/resetMapSelectionInputs'
import Guard from '~/client/src/shared/utils/Guard'

import ApiAuthService from '../../shared/services/ApiAuthService'
import ProcoreService from '../../shared/services/ProcoreService'
import StruxHubAuthService from '../../shared/services/StruxHubAuthService'
import RootStore from '../../shared/stores/Root.store'
import GraphExecutor from '../../shared/utils/GraphExecutor'

export default class MobileRootStore extends RootStore {
  public common: MobileCommonStore

  public constructor(
    configuration: IAppConfig,
    public state: MobileInitialState,
    public eventsStore: MobileEventStore,
    apiAuthService: ApiAuthService,
    struxHubAuthService: StruxHubAuthService,
    procoreService: ProcoreService,
    graphExecutor: GraphExecutor,
    isTestEnv: boolean,
  ) {
    super(
      state,
      configuration,
      eventsStore,
      MobileCommonStore,
      apiAuthService,
      struxHubAuthService,
      procoreService,
      graphExecutor,
      isTestEnv,
      true,
    )

    Guard.requireAll({
      state,
      apiAuthService,
      eventsStore,
    })

    makeObservable(this)
  }

  @action
  public clearStoresData() {
    this.clearOutTrackingData()
    this.state.clearProjectFilterSelections()

    this.messagesStore.clearList()
    clearProjectNotifications(
      this.notificationsStore,
      this.notificationsListStore,
    )
    this.deliveriesStore.clearList()
    this.basemapsStore.clearList()
    this.sitemapsStore.clearList()
    resetMapSelectionInputs(this.globeViewsStore, this.state)
    this.sitemapItemsStore.clearList()
    this.projectTeamsStore.clearList()
    this.projectRolesStore.clearList()
    this.operationRulesStore.clearList()
    this.weatherForecastsStore.clearData()
    this.recurringDeliveriesSettingsStore.clearData()
    this.concreteDirectOrdersStore.clearData()
    this.concreteDirectPayloadsStore.clearData()
    this.materialsStore.clearList()
    this.materialCategoryStore.clearList()
    this.offloadingEquipmentsStore.clearList()
    this.equipmentResourcesStore.clear()
    this.sensorResourcesStore.clear()
    this.struxTagHistoryStore.clear()
    this.materialResourcesStore.clear()
    this.formCategoriesStore.clearList()
    this.sharedDeliveriesStore.clearList()
    this.sharedSitePermitStore.clearList()
    this.projectLocationsStore.clearList()
  }
}
